import { AjaxCall, basicRetryPolicy, getHttpDetails, isHttpRetry } from 'api/basicApi';
import { SettingsInjections } from 'generics/settingsInjections';

// re export
export { basicRetryPolicy, getHttpDetails, isHttpRetry };

////////////////////////////////////////////
// class CharAPICall
export class CharAPICall  extends AjaxCall {


  constructor ( command )  {
    super( command )

    let crd=SettingsInjections.getCredentials();

    this.appendHeader( "action", command );
    this.appendHeader( "token", crd.token );
  }
};

